module.exports = function() {
  return new Worker(__webpack_public_path__ + "899d02bc6a97f0263642.worker.js");
};